import React, { useEffect } from "react";

import { Form, FormGroup, Input, Toggle } from "design-react-kit";

import secureLocalStorage from "react-secure-storage";

const NotificationEditForm = ({
  notificationData,
  setNotificationData,
  setIsVerified,
  invalidProperties,
  hasPaymentNotice,
}) => {
  const toggleVerifiedHandler = (e) => {
    setIsVerified(e.target.checked);
  };

  const edit = secureLocalStorage.getItem("edit");

  useEffect(() => {
    const inputs = document.querySelectorAll("input");
    if (!edit) {
      inputs.forEach((input) => input.setAttribute("readonly", true));
    } else {
      inputs.forEach((input) => input.removeAttribute("readonly"));
    }
  }, [edit]);

  useEffect(() => {
    const inputs = document.querySelectorAll(".error-border");
    inputs.forEach((input) => {
      input.classList.remove("error-border");
      const inputParent = input.closest(".notifEditForm-input.form-group");
      if (inputParent !== null) {
        const errorMessage = inputParent.lastElementChild;
        inputParent.removeChild(errorMessage);
      }
    });
    if (invalidProperties !== null && invalidProperties !== undefined) {
      invalidProperties.forEach((item) => {
        if (
          !hasPaymentNotice &&
          (item.propertyName === "mainPaymentNoticeCode" ||
            item.propertyName === "secondaryPaymentNoticeCode" ||
            item.propertyName === "creditorFiscalCode")
        ) {
          return;
        }
        const input = document.getElementById(item.propertyName);
        const inputParent = input.closest(".notifEditForm-input.form-group");
        const paragraph = document.createElement("p");
        input.classList.add("error-border");
        item.errors.forEach((err, i) => {
          const span = document.createElement("span");
          span.innerText = err;
          span.style.display = "block";
          span.id = item.propertyName + i;
          if (err === "Configurazione mancante!") {
            span.classList.add("icon-w");
            span.classList.add("warning-message");
          } else {
            span.classList.add("icon-p");
            span.classList.add("error-message");
          }
          paragraph.appendChild(span);
        });
        inputParent.appendChild(paragraph);
      });
    }
  }, [invalidProperties, hasPaymentNotice]);

  return (
    <Form className="mr-auto ml-3 mt-3 edit-form">
      <h5 style={{ fontWeight: "600" }}>
        {edit ? "Valori da verificare" : "Valori verificati"}{" "}
      </h5>
      {edit && (
        <p style={{ fontSize: "10px", marginBottom: "2rem" }}>
          Tutti i campi contrassegnati con un asterisco (*) sono obbligatori
        </p>
      )}
      <p className="form-paragraph">Dati destinatario</p>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="recipientName"
            type="text"
            label="Destinatario (Nome e cognome) *"
            placeholder={
              edit
                ? "Inserisci Destinatario (Nome e cognome)"
                : "Destinatario (Nome e cognome)"
            }
            value={notificationData?.recipientName}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  recipientName: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="recipientFiscalCode"
            type="text"
            label="Destinatario (CF/PIVA) *"
            placeholder={
              edit
                ? "Inserisci Destinatario (CF/PIVA)"
                : "Destinatario (CF/PIVA)"
            }
            value={notificationData?.recipientFiscalCode}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  recipientFiscalCode: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="recipientAddress"
            type="text"
            label="Destinatario (Indirizzo Via-Civico) *"
            placeholder={
              edit
                ? "Inserisci Destinatario (Indirizzo Via-Civico)"
                : "Destinatario (Indirizzo Via-Civico)"
            }
            value={notificationData?.recipientAddress}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  recipientAddress: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="recipientMunicipality"
            type="text"
            label="Destinatario (Indirizzo Comune) *"
            placeholder={
              edit
                ? "Inserisci Destinatario (Indirizzo Comune)"
                : "Destinatario (Indirizzo Comune)"
            }
            value={notificationData?.recipientMunicipality}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  recipientMunicipality: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="recipientPostalCode"
            type="text"
            label="Destinatario (Indirizzo CAP) *"
            placeholder={
              edit
                ? "Inserisci Destinatario (Indirizzo CAP)"
                : "Destinatario (Indirizzo CAP)"
            }
            value={notificationData?.recipientPostalCode}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  recipientPostalCode: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="recipientProvince"
            type="text"
            label="Destinatario (Indirizzo Provincia) *"
            placeholder={
              edit
                ? "Inserisci Destinatario (Indirizzo Provincia)"
                : "Destinatario (Indirizzo Provincia)"
            }
            value={notificationData?.recipientProvince}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  recipientProvince: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>

      {hasPaymentNotice && (
        <>
          <div className="form-row">
            <FormGroup className="col-sm-12 m-0">
              <Input
                className="notifEditForm-input"
                id="mainPaymentNoticeCode"
                type="text"
                label="Codice Avviso (primario) *"
                placeholder={
                  edit
                    ? "Inserisci Codice Avviso (primario)"
                    : "Codice Avviso (primario)"
                }
                value={notificationData?.mainPaymentNoticeCode}
                onChange={(e) =>
                  setNotificationData((curState) => {
                    return {
                      ...curState,
                      mainPaymentNoticeCode: e.target.value,
                    };
                  })
                }
              />
            </FormGroup>
          </div>
          <div className="form-row">
            <FormGroup className="col-sm-12 m-0">
              <Input
                className="notifEditForm-input"
                id="secondaryPaymentNoticeCode"
                type="text"
                label="Codice Avviso (alternativo)"
                placeholder={
                  edit
                    ? "Inserisci Codice Avviso (alternativo)"
                    : "Codice Avviso (alternativo)"
                }
                value={notificationData?.secondaryPaymentNoticeCode}
                onChange={(e) =>
                  setNotificationData((curState) => {
                    return {
                      ...curState,
                      secondaryPaymentNoticeCode: e.target.value,
                    };
                  })
                }
              />
            </FormGroup>
          </div>
          <div className="form-row">
            <FormGroup className="col-sm-12 m-0">
              <Input
                className="notifEditForm-input"
                id="creditorFiscalCode"
                type="text"
                label="Ente creditore (CF) *"
                placeholder={
                  edit ? "Inserisci Ente creditore (CF)" : "Ente creditore (CF)"
                }
                value={notificationData?.creditorFiscalCode}
                onChange={(e) =>
                  setNotificationData((curState) => {
                    return {
                      ...curState,
                      creditorFiscalCode: e.target.value,
                    };
                  })
                }
              />
            </FormGroup>
          </div>
        </>
      )}
      <p className="form-paragraph">Dati notifica</p>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="mainPaymentAmount"
            type="text"
            label="Importo della notifica *"
            placeholder={
              edit
                ? "Inserisci Importo della notifica"
                : "Importo della notifica"
            }
            value={notificationData?.mainPaymentAmount}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  mainPaymentAmount: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="subject"
            type="text"
            label="Oggetto *"
            placeholder={edit ? "Inserisci Oggetto" : "Oggetto"}
            value={notificationData?.subject}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  subject: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>
      <div className="form-row">
        <FormGroup className="col-sm-12 m-0">
          <Input
            className="notifEditForm-input"
            id="protocolNumber"
            type="text"
            label="Protocollo *"
            placeholder={edit ? "Inserisci Protocollo" : "Protocollo"}
            value={notificationData?.protocolNumber}
            onChange={(e) =>
              setNotificationData((curState) => {
                return {
                  ...curState,
                  protocolNumber: e.target.value,
                };
              })
            }
          />
        </FormGroup>
      </div>
      {edit && (
        <FormGroup
          check
          className="form-check-group d-flex align-items-center justify-content-start save"
        >
          <Toggle id="verified" onChange={(e) => toggleVerifiedHandler(e)} />
          <span className="mb-2">Verificato</span>
        </FormGroup>
      )}
    </Form>
  );
};

export default NotificationEditForm;
